import { CurrencyDescription } from './currency-description.model';
import { Utility } from '../../core/interceptor/utility';
import { Network } from './network.model';

export class Currency {
  id!: string;
  name!: string;
  iconPath!: string;
  withdrawFee: number;
  description: CurrencyDescription[];
  irrBuyPrice: number;
  irrSellPrice: number;
  usdcPrice: number;
  usdtPrice: number;
  irrPrice: number;
  isEnabled!: boolean;
  hasTag: boolean;
  color!: string;
  price!: number;
  decimalPrecision!: number;
  demoInitAmount!: number;
  dailyWithdrawPrice!: number;
  monthlyWithdrawPrice!: number;
  minimumWithdrawAmount: number;
  network: string;
  networks!: Network[];

  constructor(input: any = {}) {
    this.id = input.id;
    this.name = input.name;
    this.description =
      input.description?.map((each: any) => {
        const camelize = Utility.camelize(each)
        if (camelize.similarCurrencies){
          camelize.similarCurrencies = JSON.parse(camelize.similarCurrencies)
        }else{
          camelize.similarCurrencies = [];
        }
        return camelize;
      }) ?? [];
    this.iconPath = input.icon_path;
    this.irrBuyPrice = Math.round(input.irr_buy_price / 10 || 0);
    this.irrSellPrice = Math.round(input.irr_sell_price / 10 || 0);
    this.usdcPrice = input.usdc_price;
    this.usdtPrice = +input.usdt_price;
    this.irrPrice = +input.irr_price;
    if (this.irrPrice) {
      this.irrPrice /= 10;
    }
    this.withdrawFee = input.withdraw_fee;
    this.minimumWithdrawAmount = +input.minimum_withdraw_amount;
    this.hasTag = input.has_tag;
    this.color = input.color;
    this.price = input.price;
    this.decimalPrecision = +input.decimal_precision;
    this.demoInitAmount = +input.demo_init_amount;
    this.dailyWithdrawPrice = +input.daily_withdraw_price;
    this.monthlyWithdrawPrice = +input.monthly_withdraw_price;
    this.isEnabled = !!input.is_enabled;
    this.network = input.network;
    if (this.id === 'IRR') {
      this.usdcPrice = Math.round(this.usdcPrice / 10 || 0);
      this.demoInitAmount = Math.round(this.demoInitAmount / 10 || 0);
      this.dailyWithdrawPrice = Math.round(this.dailyWithdrawPrice / 10 || 0);
      this.monthlyWithdrawPrice = Math.round(this.monthlyWithdrawPrice / 10 || 0);
      this.minimumWithdrawAmount = Math.round(this.minimumWithdrawAmount / 10 || 0);
    }
    this.networks = input.networks?.map((network: any) => Utility.camelize(network) as Network);
  }

  rialToTooman(): void {
    if (this.id === 'IRR') {
      this.usdcPrice = this.usdcPrice * 10;
      this.demoInitAmount = this.demoInitAmount * 10;
      this.dailyWithdrawPrice = this.dailyWithdrawPrice * 10;
      this.monthlyWithdrawPrice = this.monthlyWithdrawPrice * 10;
      this.minimumWithdrawAmount = this.minimumWithdrawAmount * 10;
    }
  }
}
